import {
  quotesSchemasService,
  type QuoteSchema,
} from '@/services/quotes-schemas';
import { useQuery } from '@tanstack/react-query';

export function useQuoteSchemas(category: string) {
  return useQuery({
    queryKey: ['quotes-schemas', category],
    queryFn: async (): Promise<QuoteSchema> => {
      const response = await quotesSchemasService.getQuoteSchema(category);
      if (!response.success)
        throw new Error(response.error || 'Erro ao carregar schema');
      return response.data!;
    },
    staleTime: 60 * 60 * 1000,
    enabled: !!category,
  });
}
